import React from 'react'

function ProductAnalyticsNavGuest() {
  return (
    <div className="card card--flat">
      <ul className="nav-tabs">
        <li className="tab is-disabled">
          <a href="javascript:;">Marketplace Statistics</a>
        </li>
        <li className="tab is-disabled">
          <a href="javascript:;">My Models</a>
        </li>
        <li className="tab is-disabled">
          <a href="javascript:;">Model Improvements</a>
        </li>
        <li className="tab is-active">
          <a href="/profile/analytics/about">About Analytics</a>
        </li>
      </ul>
    </div>
  )
}

export default ProductAnalyticsNavGuest
